module.exports = function () {
    $('.author-details').children().each(function () {
        var $textElement;

        if ($(this).hasClass('author-link')) {
            $textElement = $('.author-text span[data-id="' + $(this).data('id') + '"]');
            $textElement.replaceWith('<a href="' + $(this).data('href') + '">' + $textElement.html() + '</a>');
        }
        else if ($(this).hasClass('author-tooltip')) {
            $textElement = $('.author-text span[data-id="' + $(this).data('id') + '"]');
            if ($(this).data('href')) {
                var $newTextElement = $('<a href="' + $(this).data('href') + '">' + $textElement.html() + '</a>');
                $(this).appendTo($newTextElement);
                $textElement.replaceWith($newTextElement);
            } else {
                $(this).appendTo($textElement);
            }
        }
    });
}